import { z } from "zod";

export const zoneName = z.enum(["EXO", "STD", "EU", "BREXIT", "HT"]);
export const category = z.enum(["INTERNATIONAL", "ROAMING"]);

const zone = z.object({
  category,
  name: zoneName,
  displayName: z.object({
    id: z.number(),
    pl: z.string(),
  }),
  description: z.object({
    id: z.number(),
    pl: z.string(),
  }),
});

export const serverResponse = z.array(zone);

export type IZone = z.infer<typeof zone>;
